import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY_ACTIVITIES_FOLLOWERS } from 'Data/keys/QueryKeys';
import { ActivitiesApi } from 'Data/ActivitiesApi';

export const useQueryFollowers = (topicId: string | null) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [QUERY_KEY_ACTIVITIES_FOLLOWERS, topicId],
    staleTime: 60 * 5 * 1000, // 5 minutes
    enabled: !!topicId,
    queryFn: async () => {
      const response = await ActivitiesApi.listFollowers(topicId || '');
      return response.data.data;
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
